import styled from "styled-components";

const background = "#f2f2f2";

export const LoginContainer = styled.div`
  height: 100vh;
  width: 100vw;
  background-color: ${background};
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const LoginForm = styled.div`
  margin: auto;
  width: 50vw;
  height: 50vh;
  background-color: white;
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 64px;
  Button {
    margin-top: 32px;
    align-self: flex-start;
  }
  h2 {
    font-size: 2rem;
    strong {
      text-decoration: underline;
    }
  }
`;
